import React from 'react';
import { WifiIcon, CloudIcon, BatteryIcon, ZapIcon } from 'lucide-react';
export function HomeMonitor() {
  return <div className="bg-white rounded-xl shadow-sm p-6 mb-6" data-id="element-230">
      <h2 className="text-xl font-semibold mb-4" data-id="element-231">WattWise Hub</h2>
      <div className="flex flex-col lg:flex-row gap-8" data-id="element-232">
        <div className="flex-1" data-id="element-233">
          <div className="aspect-square max-w-[300px] mx-auto bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 flex items-center justify-center relative" data-id="element-234">
            <div className="w-4/5 h-4/5 bg-white rounded-2xl shadow-md flex flex-col items-center justify-center p-4" data-id="element-235">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-400 to-green-600 mb-3 flex items-center justify-center" data-id="element-236">
                <ZapIcon size={28} className="text-white" data-id="element-237" />
              </div>
              <div className="text-center" data-id="element-238">
                <h3 className="font-medium" data-id="element-239">WattWise Hub</h3>
                <p className="text-xs text-gray-500" data-id="element-240">Connected</p>
              </div>
            </div>
            <div className="absolute top-4 right-4 flex gap-2" data-id="element-241">
              <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" data-id="element-242"></div>
            </div>
            <div className="absolute bottom-4 left-4 flex gap-2" data-id="element-243">
              <WifiIcon size={16} className="text-green-600" data-id="element-244" />
              <CloudIcon size={16} className="text-green-600" data-id="element-245" />
            </div>
          </div>
        </div>
        <div className="flex-1" data-id="element-246">
          <h3 className="text-lg font-medium mb-3" data-id="element-247">Device Specifications</h3>
          <div className="space-y-3" data-id="element-248">
            <div className="flex items-center justify-between pb-2 border-b border-gray-100" data-id="element-249">
              <span className="text-gray-600" data-id="element-250">Microcontroller</span>
              <span className="font-medium" data-id="element-251">ESP32-C3</span>
            </div>
            <div className="flex items-center justify-between pb-2 border-b border-gray-100" data-id="element-252">
              <span className="text-gray-600" data-id="element-253">Sub-GHz Radio</span>
              <span className="font-medium" data-id="element-254">CC1101 (433 MHz)</span>
            </div>
            <div className="flex items-center justify-between pb-2 border-b border-gray-100" data-id="element-255">
              <span className="text-gray-600" data-id="element-256">Wi-Fi</span>
              <span className="font-medium" data-id="element-257">2.4 GHz (802.11 b/g/n)</span>
            </div>
            <div className="flex items-center justify-between pb-2 border-b border-gray-100" data-id="element-258">
              <span className="text-gray-600" data-id="element-259">Power Input</span>
              <span className="font-medium" data-id="element-260">5V DC (USB-C)</span>
            </div>
            <div className="flex items-center justify-between pb-2 border-b border-gray-100" data-id="element-261">
              <span className="text-gray-600" data-id="element-262">Power Consumption</span>
              <span className="font-medium" data-id="element-263"> 1 W (idle)</span>
            </div>
            <div className="flex items-center justify-between pb-2 border-b border-gray-100" data-id="element-264">
              <span className="text-gray-600" data-id="element-265">Dimensions</span>
              <span className="font-medium" data-id="element-266">8 cm x 8 cm x 2 cm</span>
            </div>
            <div className="flex items-center justify-between" data-id="element-267">
              <span className="text-gray-600" data-id="element-268">Firmware</span>
              <span className="font-medium" data-id="element-269">v1.2.0 (OTA enabled)</span>
            </div>
          </div>
        </div>
        <div className="flex-1" data-id="element-270">
          <h3 className="text-lg font-medium mb-3" data-id="element-271">Status & Connectivity</h3>
          <div className="space-y-4" data-id="element-272">
            <div className="bg-gray-50 rounded-lg p-4" data-id="element-273">
              <div className="flex items-center justify-between mb-2" data-id="element-274">
                <span className="text-gray-600" data-id="element-275">Wi-Fi Status</span>
                <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-medium" data-id="element-276">
                  Connected
                </span>
              </div>
              <div className="flex items-center gap-1" data-id="element-277">
                <WifiIcon size={16} className="text-green-600" data-id="element-278" />
                <span className="text-sm" data-id="element-279">HomeNetwork_2.4G</span>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4" data-id="element-280">
              <div className="flex items-center justify-between mb-2" data-id="element-281">
                <span className="text-gray-600" data-id="element-282">Cloud Status</span>
                <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-medium" data-id="element-283">
                  Online
                </span>
              </div>
              <div className="flex items-center gap-1" data-id="element-284">
                <CloudIcon size={16} className="text-green-600" data-id="element-285" />
                <span className="text-sm" data-id="element-286">Last sync: 2 minutes ago</span>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4" data-id="element-287">
              <div className="flex items-center justify-between mb-2" data-id="element-288">
                <span className="text-gray-600" data-id="element-289">Connected Devices</span>
                <span className="font-medium" data-id="element-290">4</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-291">
                <div className="bg-green-600 h-2.5 rounded-full" style={{
                width: '40%'
              }} data-id="element-292"></div>
              </div>
              <div className="flex justify-between mt-1 text-xs text-gray-500" data-id="element-293">
                <span data-id="element-294">0</span>
                <span data-id="element-295">10</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}